 import { FaRocket, FaLightbulb, FaChartLine  } from 'react-icons/fa';
 import {  GiArtificialIntelligence} from 'react-icons/gi';
 import {FiGlobe,FiAward,FiUsers,FiLayers,FiClock,FiBarChart2} from 'react-icons/fi'
 
 const features = [
    // {
    //   icon: <FaRocket className="text-3xl text-blue-500" />,
    //   title: "Lightning Fast",
    //   description: "Optimized for maximum performance and speed"
    // },
    {
      icon: <FaLightbulb className="text-3xl text-purple-500" />,
      title: "Innovative Solutions",
      description: "Cutting-edge technology for modern problems"
    },
    {
      icon: <FaChartLine className="text-3xl text-green-500" />,
      title: "Data Driven",
      description: "Metrics that matter for your business growth"
    },
    {
      icon: <GiArtificialIntelligence className="text-3xl text-orange-500" />,
      title: "AI Powered",
      description: "Smart features that learn and adapt"
    },
    { icon: <FiGlobe className="text-3xl text-blue-500"/>, title: "Global Reach", description: "Operating in 15+ countries worldwide" },
        { icon: <FiUsers className="text-3xl text-blue-500"/>, title: "Dedicated Team", description: "100+ skilled professionals" },
        { icon: <FiAward className="text-3xl text-blue-500"/>, title: "Industry Recognition", description: "Multiple award-winning projects" },
        { icon: <FiLayers className="text-3xl text-blue-500"/>, title: "Full Stack", description: "End-to-end solution provider" },
        { icon: <FiClock className="text-3xl text-blue-500"/>, title: "Fast Delivery", description: "Agile development process" },
        // { icon: <FiBarChart2 className="text-3xl text-blue-500"/>, title: "Data-Driven", description: "Metrics-focused approach" },
  ];


  export default features;